import toNumber from 'lodash/toNumber'
import type { ListField, OnFilterFunction } from '@ztechapps/common.hook'
import { ListFieldTypeEnum, SearchTypeEnum } from '@ztechapps/common.hook'
import isEmpty from 'lodash/isEmpty'

export const handleSearchFn = ({
  searchType,
  searchValue,
  fields,
}: {
  searchType: SearchTypeEnum
  searchValue: string
  fields: ListField[]
}) => {
  let filterObject = {}

  //if searchValue  is NOT empty, then build a searchString
  if (searchValue && searchValue !== '') {
    const searchObj =
      searchType === SearchTypeEnum.startsWith
        ? { $regex: `^${searchValue}`, $options: 'i' }
        : { $regex: searchValue, $options: 'i' }

    //this will search by fields only
    if (fields?.length === 1) {
      const searchString = JSON.stringify(searchObj)

      return {
        searchString,
        searchObject: searchValue ? { $or: [{ [fields?.[0]?.name]: searchObj }] } : {},
        searchFields: fields,
      }
    }

    filterObject = { $or: [] }

    //iterate through all fields if there is something to search
    fields?.forEach((m) => {
      const obj = {}

      if (m.type && m.type.toLowerCase() === ListFieldTypeEnum.array) {
        obj[m.name] = { $elemMatch: searchObj }
      } else if (m.type && m.type.toLowerCase() === ListFieldTypeEnum.number) {
        const value = toNumber(searchValue)
        if (!isNaN(value)) obj[m.name] = value
      } else if (m.type && m.type.toLowerCase() === ListFieldTypeEnum.objectArray) {
        // the name should follow by the following format
        //contacts.$.address1.gps.lat, take note about the dollar sign to indicate about the array
        //split the m.name by "."
        const objectArrayName = m.name.split('.', 3)
        //the first item is the name
        obj[objectArrayName[0]] = { $elemMatch: { [objectArrayName[2]]: searchObj } }
      } else {
        obj[m.name] = searchObj
      }

      //sometimes obj is just empty value, specially if number type and the value that was used is not a number
      if (!isEmpty(obj)) {
        filterObject['$or'].push(obj)
      }
    })
  }

  const searchString = JSON.stringify(filterObject)

  return { searchString, searchObject: filterObject, searchFields: fields }
}

export type UseMongoSearchResult = (
  searchValue?: string,
  searchType?: SearchTypeEnum,
  searchFields?: ListField[]
) => void
export const useMongoSearch = ({
  searchType = SearchTypeEnum.fullText,
  onFilter,
  searchFields,
  searchValue,
}: {
  searchType?: SearchTypeEnum
  onFilter: OnFilterFunction
  searchFields?: ListField[]
  searchValue?: string
}): UseMongoSearchResult => {
  return (_searchValue?: string, _searchType?: SearchTypeEnum, _searchFields?: ListField[]) => {
    _searchValue = _searchValue ?? searchValue
    _searchType = _searchType ?? searchType
    _searchFields = _searchFields ?? searchFields

    const { searchObject } = handleSearchFn({
      searchType: _searchType,
      searchValue: _searchValue,
      fields: _searchFields,
    })
    onFilter({ searchObject, searchValue: _searchValue })
  }
}
